<svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.68066 38.4288L20.5545 20.5549L2.68066 2.68109" stroke="white" stroke-width="5.36216" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
